module.exports = __webpack_public_path__ + "front/img/nav-bg.62388eba.png";